
import React from "react";
import { StartupAccount } from "@/types/startup";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { BookOpen, Plus } from "lucide-react";

interface StartupCoursesProps {
  startupAccount: StartupAccount;
}

const StartupCourses: React.FC<StartupCoursesProps> = ({ startupAccount }) => {
  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold">Courses</h2>
          <p className="text-muted-foreground">Create educational content for teens</p>
        </div>
        <Button>
          <Plus className="h-4 w-4 mr-2" />
          Create Course
        </Button>
      </div>

      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <BookOpen className="h-5 w-5" />
            Course Builder Coming Soon
          </CardTitle>
          <CardDescription>
            The mini-course creator will allow you to build educational content with lessons, videos, and quizzes.
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-muted-foreground">
            This feature will be available in the next update. You'll be able to create engaging courses
            to share your expertise with teen users on the platform.
          </p>
        </CardContent>
      </Card>
    </div>
  );
};

export default StartupCourses;
